import { ReminderItem } from "../../types/reminderTypes";

/**
 * Create tooltip listing all item names for a patient reminder
 */
export const createItemsTooltip = (items: ReminderItem[]): string => {
  if (!items || items.length === 0) {
    return "Nema artikala";
  }

  return items
    .map(
      (item) =>
        item.itemResponse?.name || item.articleName || "Nepoznat artikal"
    )
    .join("\n");
};
